export default __webpack_public_path__ + "static/media/quote03@2x.e529e23c.png";